/**=========================================================
 * Module: privacy.js
 * Privacy Controller
 =========================================================*/

App.controller('PrivacyController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', '$http', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, $http, D) {
    "use strict";
   
    if(!$rootScope.user.id){
        $state.go('page.login', angular.fromJson($state.params.params));
    }

    $http({
        method: 'GET',
        url: '/app/files/privacy.' + $rootScope.user.language + '.'+$rootScope.user.groupType+'.html'
      }).then(function successCallback(response) {
          $scope.privacyText = response.data;
      });

    $scope.submitting = false;
    $scope.accept = function(){
        $scope.submitting = true;
        var model = $rootScope.user;
        model.gdprcheck = true;
        D.save('account', model).then(function(account){
            if(account.pwdS!==null && account.pwdS!==undefined && account.pwdS<=2){
                $state.params.goTo = 'app.entity';
                $state.params.params = '{\"action\":\"password\",\"type\":\"user\",\"filter\":\"'+account.id+'\"}';
            } 
            $state.go($state.params.goTo || 'app.dashboard', angular.fromJson($state.params.params));
        }).catch(console.error);
    }
    
    
  }
]);
